import { createFileRoute } from "@tanstack/react-router";

import { Activities } from "@/features/marketing/Activities";

export const Route = createFileRoute("/activities")({
  component: Activities,
});
